import userImg from 'assets/images/account-page/user-icon-lg.png';
import classNames from "classnames";
import React from "react";
import { getBrandName } from 'utils/brand';
import { Field, ErrorMessage } from "formik";
import css from "./style.scss";
import accountCSS from "../style.scss";
import { useForm } from "react-hook-form";
import TextField from "components/MultiStepForm/TextField"
import DropdownField from "components/MultiStepForm/DropdownField"
import CheckboxField from "components/MultiStepForm/CheckboxField"
import checkboxCSS from "components/MultiStepForm/style.scss"
import { useFormContext } from '../../../context/FormContext';
import { useEffect } from 'react';
import UploadProfilePicture from '../components/uploadProfilePicture';
import { useFormContext as useRHFormContext } from "react-hook-form";
import { useState } from 'react';
import { getFullDataURL } from './validationSchemas';
import CreditCardDropdown from '../components/CreditCardDropdown';
import { selectCardList, selectLeadAutomator  } from "data/user/selectors";
import { useSelector } from 'react-redux';
import PasswordStrength from '../../../components/PasswordStrengthIndecator';
import { useInvestorOutreachEntitlement } from '../Sections/useInvestorOutreachEntitlement';

const CreateTeamProfile = (props) => {

const cardList = useSelector(selectCardList);
const selectLeadAutomatorSection = useSelector(selectLeadAutomator)?.toJS();

const hasListAutomatorSubscription =
  !!selectLeadAutomatorSection?.accountPlanMrcs?.length;

  const { formData } = useFormContext();

  const { entitled: hasInvestorOutreachSubscription } = useInvestorOutreachEntitlement(formData.type !== 'SCOUT');

  const { setValue, watch, getValues, touched, formState } = useRHFormContext();
  const { touchedFields } = formState;
  const [imageUrl, setImageUrl] = useState(formData?.profilePicture ? formData?.profilePicture : null);

  const setUploadImage = (field, value,e) => {
    if(value) {
      setValue(field, value); // Update the form field with the image
      setImageUrl(`data:image/png;base64,${value}`); // Set preview image
    } else {
      e.preventDefault();
      setValue('profilePicture', []);
      setImageUrl(null);
    }
  };

  useEffect(() => {
    setImageUrl(formData?.profilePicture)
  }, [formData?.profilePicture])


  // setFieldValue


  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "You have unsaved changes. Are you sure you want to refresh?";
      return ""
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleCardChange = (selectedOption, type) => {
    setValue(type, selectedOption?.paymentMethodId);
  }

  useEffect( () => {
    if(cardList?.length > 0){
      if( !getValues("defaultSubsPaymentMethodId") )
        setValue('defaultSubsPaymentMethodId', cardList[0]?.paymentMethodId);
      if( !getValues("defaultInAppPaymentMethodId") )
        setValue('defaultInAppPaymentMethodId', cardList[0]?.paymentMethodId);
    }
  },[cardList])


  return (
    <div className="container">
      <div className={css.clsTMCreateProfileSec}>
        <div className={css.clsTMCreateProfileHead}>
          <h2 className={css.clsMainTitle}>{props?.review ? 'Review Team Member Profile' : 'Create a Profile for Your New Team Member'}</h2>
          <p className={css.clsHeadPara}>{formData.type === 'SCOUT' ?
          "Enter Profile and Account Information for Your Team Member" :
          "Enter Profile and Account Information and Usage Limitations for Your Team Member"}</p>
        </div>

        <div className={css.clsTMCreateProfileForm}>
          <div className="row justify-content-center" style={{"padding-bottom": '13rem'}}>
            <div className="col-lg-8">
              <h4 className={css.clsRequiredTxt}>Indicates Required Field<span className={css.text_primary}>*</span></h4>
              <div className={css.clsFormSction}>
                <h4 className={classNames(css.clsFormTitle, css.mb_16)}> General Information </h4>

                <div className="flex-column-reverse flex-lg-row justify-content-center row">
                  <div className={classNames("col-lg-6 col-12")}>
                    <TextField name="firstName" label="First Name" required={true} />
                    <TextField name="lastName" label="Last Name" required={true} />
                    <TextField name="phone" label="Phone Number" required={true} numbers={true} />
                  </div>

                  <div className={classNames("col-lg-6 col-12")}>
                    <div className={classNames(css.pb_12, css.clsFormGroup, "d-flex flex-column justify-content-center align-items-center")}>
                      <div className={accountCSS.clsSelectProfileImg} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <label className={classNames(css.clsFormLabel)}>  Profile Picture </label>
                        <div className={accountCSS.clstProfileImg}>
                          {imageUrl ? (
                              <img src={getFullDataURL(imageUrl)} alt="Profile" />
                            ) : (
                              <img src={userImg} alt="Profile" />
                            )}
                        </div>
                        <UploadProfilePicture key={imageUrl ? imageUrl : 'noImage'} label={imageUrl ? 'Edit Photo' : 'Add Photo'} filed={'profilePicture'} setFieldValue={setUploadImage}  setImageUrl={setImageUrl} />
                        {imageUrl && (
                                <a  className={accountCSS.clsAddTxt} onClick={(e) => setUploadImage('profilePicture' , null,e)}>Remove Photo</a>
                            )}

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={css.clsFormSction}>
                <h4 className={classNames(css.clsFormTitle, css.mb_24)}>Account Information </h4>
                <div className="flex-column-reverse flex-lg-row justify-content-center row">
                  <div className={classNames("col-lg-6 col-12")}>
                    <TextField name="username" label="Email/Username" placeholder="Email Address" />
                  </div>
                  <div className={classNames("col-lg-6 col-12")}>
                    <TextField name="confirmEmail" label="Confirm Email/Username" placeholder="Confirm Email Address" />
                  </div>
                  <div className={classNames("col-lg-6 col-12")}>
                    <TextField name="newPwd" label="New Password" placeholder="New Password" type="password" hideErrorMsg />
                    <PasswordStrength password={getValues("newPwd")}  email={getValues("username")} fname={getValues("firstName")} lname={getValues("lastName")}/>
                    </div>
                  <div className={classNames("col-lg-6 col-12")}>
                    <TextField name="confirmPassword" label="Confirm New Password" placeholder="Confirm New Password" type="password" successText={(getValues("confirmPassword") && getValues("confirmPassword") === getValues("newPwd")) ? "Passwords Match": null } delayOnChangeValidation={800} avoidDelay={(val) => val === getValues("newPwd")} />
                  </div>
                </div>
              </div>

            {formData.type !== 'SCOUT' && (
              <>
              <div className={css.clsFormSction}>
                <h4 className={classNames(css.clsFormTitle, css.mb_24)}>Usage Limits </h4>
                <div className="flex-column-reverse flex-lg-row justify-content-center row">
                  <div className={classNames("col-lg-6 col-12")}>
                     <TextField name="propertyLimit" label="Save Limit (Monthly)" placeholder="Save Limit" numbers={true} required={false} maxLength={12} />
                  </div>
                  <div className={classNames("col-lg-6 col-12")}>
                  <TextField name="spendingLimit" label="Spending Limit (Monthly)" placeholder="Spending Limit" numbers={true} maxLength={12} required={false} />
                  </div>
                </div>
              </div>

              <div className={css.clsFormSction}>
                <h4 className={classNames(css.clsFormTitle, css.mb_24)}>Billing </h4>
                <div className="flex-column-reverse flex-lg-row justify-content-center row">
                  <div className={classNames("col-lg-6 col-12")}>
                  <div className={classNames(css.clsFormGroup)}>
                  <label className={classNames(css.clsFormLabel)}> Default for Subscriptions</label>
                    <CreditCardDropdown
                      tag={false}
                      label="Default for Subscriptions"
                      options={cardList}
                      selectedId={getValues("defaultSubsPaymentMethodId")}
                      onChange={(selectedOption) => handleCardChange(selectedOption, 'defaultSubsPaymentMethodId')}
                    />
                    </div>
                  </div>
                  <div className={classNames("col-lg-6 col-12")}>
                  <div className={classNames(css.clsFormGroup)}>
                  <label className={classNames(css.clsFormLabel)}> Default For In App Purchases</label>
                    <CreditCardDropdown
                      tag={false}
                      selectedId={getValues("defaultInAppPaymentMethodId")}
                      name="spendingLimit"
                      label="Default For In App Purchases"
                      options={cardList}
                      onChange={(selectedOption) => handleCardChange(selectedOption, 'defaultInAppPaymentMethodId')}
                    />
                    </div>
                  </div>
                </div>
              </div>

              {hasListAutomatorSubscription && (
              <div className={css.clsFormSction}>
                <h4 className={classNames(css.clsFormTitle, css.mb_24)}>Click to Dial</h4>
                <div className="row">
                  <div className={classNames("col-12")}>
                    <CheckboxField
                      name="allowClickToDial"
                      label={`Allow this user to make phone calls through ${getBrandName()}`}
                      containerClassName={checkboxCSS.clsBatchDialerCheckbox}
                      labelClassName={checkboxCSS.clsBatchDialerLabel}
                    />
                  </div>
                </div>
              </div>
              )}
              <div className={css.clsFormSction}>
                <h4 className={classNames(css.clsFormTitle, css.mb_24)}>Push to BatchDialer</h4>
                <div className="row">
                  <div className={classNames("col-12")}>
                    <CheckboxField
                      name="pushToBatchDialer"
                      label="Allow this user to add leads to BatchDialer."
                      containerClassName={checkboxCSS.clsBatchDialerCheckbox}
                      labelClassName={checkboxCSS.clsBatchDialerLabel}
                    />
                  </div>
                </div>
              </div>
              {hasInvestorOutreachSubscription && (
              <div className={css.clsFormSction}>
                <h4 className={classNames(css.clsFormTitle, css.mb_24)}>Investor Outreach</h4>
                <div className="row">
                  <div className={classNames("col-12")}>
                    <CheckboxField
                      name="allowInvestorOutreach"
                      label="Allow this user to access Investor Outreach."
                      containerClassName={checkboxCSS.clsBatchDialerCheckbox}
                      labelClassName={checkboxCSS.clsBatchDialerLabel}
                    />
                  </div>
                </div>
              </div>
              )}
              </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateTeamProfile;
